import React from "react";
import { Route, Switch, Redirect } from 'react-router-dom';
import asyncComponent from '../../../itrust_common/components/AsyncComponent';

const OneTimeWrap = asyncComponent(() =>
  import('../../../components/authorised/marketingBlast/costLeadsAnalytics/leads/oneTime/OneTimeWrap')
)

const RecurringWrap = asyncComponent(() =>
  import('../../../components/authorised/marketingBlast/costLeadsAnalytics/leads/recurring/RecurringWrap')
)

const CampaignLeadTrackRoutes = (
  <Switch>
    <Route exact path='/marketing-blast/campaign-lead-track/one-time' component={OneTimeWrap} />
    <Route exact path='/marketing-blast/campaign-lead-track/recurring' component={RecurringWrap} />
    <Redirect exact from="/marketing-blast/campaign-lead-track" to="/marketing-blast/campaign-lead-track/one-time" />
  </Switch>
)

export default CampaignLeadTrackRoutes;